import * as React from "react";
import { useDispatch } from "react-redux";
import ModalChapter from "../../Base/Chapters/ModalChapter";
import renderChapter from "./renderChapter";
import chapterDefs from "./chapterDefs";
import {
  destroyPatchForm,
  constants,
  update,
  useErrandComponentForm,
} from "../../../../store/errandComponents";
import { setActiveFormInstance } from "../../../../store/base";

export default function UpdateCurrentComponentForm({
  method = "PATCH",
  id,
  onCheckout,
  isOpen,
  instance,
  patchIndex,
}) {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  const formLoaded = Boolean(useErrandComponentForm(method, id));

  React.useEffect(() => {
    if (isOpen) {
      dispatch(
        setActiveFormInstance({
          storeName,
          data: instance,
        })
      );
    }
  }, [isOpen]);

  const checkout = (success) => {
    dispatch(destroyPatchForm(success));

    onCheckout();
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
  };

  const onSubmit = () => {
    setLoading(true);

    dispatch(
      update({
        id,
        successCallback: onSuccess,
        errorCallback: () => setLoading(false),
      })
    );
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) =>
        renderChapter({ key, method, storeName, patchIndex })
      }
      submitCallback={onSubmit}
      title={"Uppdatera installation"}
      onDone={onDone}
      loading={!formLoaded || loading}
      isOpen={isOpen}
    />
  );
}
